  import {
  CATEGORY_LIST_LOADING,
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_ERROR,
  GET_CATEGORY_BY_ID_LOADING,
  GET_CATEGORY_BY_ID_SUCCESS,
  GET_CATEGORY_BY_ID_ERROR,
  DELETEING_BLOG_CATEGORY,
  DELETE_BLOG_CATEGORY,
  DELETE_BLOG_CATEGORY_ERROR,
  DELETED_BLOG_CATEGORY_LIST_LOADING,
  GET_DELETED_BLOG_CATEGORY_LIST,
  GET_DELETED_BLOG_CATEGORY_LIST_ERROR,
  RESTORE_BLOG_CATEGORY_LIST_LOADING,
  RESTORE_BLOG_CATEGORY_LIST,
  RESTORE_BLOG_CATEGORY_LIST_ERROR,   
  PERMA_DELETE_BLOG_CATEGORY,
  PERMA_DELETE_BLOG_CATEGORY_ERROR,
  PERMA_DELETEING_BLOG_CATEGORY,
} from "./types";
import axios from "axios";
import { BASE_URL } from "../urls";
import { message } from "antd";

export const getList = (tokenData) => async (dispatch) => {
  dispatch({
    type: CATEGORY_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/category/active`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_CATEGORY_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_CATEGORY_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const getEntityById = (tokenData, id) => async (dispatch) => {
  dispatch({
    type: GET_CATEGORY_BY_ID_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/category/${id}`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_CATEGORY_BY_ID_SUCCESS,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_CATEGORY_BY_ID_ERROR,
        payload: error.response,
      });
    });
};

export const getDeletedList = (tokenData) => async (dispatch) => {
  dispatch({
    type: DELETED_BLOG_CATEGORY_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/category/deleted`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_DELETED_BLOG_CATEGORY_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_DELETED_BLOG_CATEGORY_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const deleteEntityById = (idList) => async (dispatch) => {
  dispatch({
    type: DELETEING_BLOG_CATEGORY,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/category/bulk/delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: DELETE_BLOG_CATEGORY,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: DELETE_BLOG_CATEGORY_ERROR,
        payload: error.response,
      });
    });
};

export const permanentDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: PERMA_DELETEING_BLOG_CATEGORY,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/category/bulk/perma-delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: PERMA_DELETE_BLOG_CATEGORY,
        payload: response,
      })
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: PERMA_DELETE_BLOG_CATEGORY_ERROR,
        payload: error.response,
      })      
      message.error(error.response.data.message);
    });
};

export const restoretDeleteEntity = (idList, history) => async (dispatch) => {
  dispatch({
    type: RESTORE_BLOG_CATEGORY_LIST_LOADING,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/category/bulk/restore`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: RESTORE_BLOG_CATEGORY_LIST,
        payload: response,
      })
      history.push("/blog-list")        
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: RESTORE_BLOG_CATEGORY_LIST_ERROR,
        payload: error.response,
      })      
      message.error(error.response.data.message);
    });
};

